import { Component, OnInit, Input, ViewChild, ElementRef, AfterViewInit, OnChanges, SimpleChanges, Output, EventEmitter, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { QuestionserviceService } from '../services/questionservice.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { ExamService } from '../services/exam.service';
import { CbtserviceService } from '../services/cbtservice.service';
import { LanguageService } from '../services/language.service';
import { ExamDetails, ScheduleOptionsProp, ScheduleQuestionAndOptions } from '../models/Exam';
import { Subject, Subscription } from 'rxjs';
import { UtilService } from '../meeting/services/util.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UnansweredQuestionsModalComponent } from '../shared/unanswered-questions-modal/unanswered-questions-modal.component';
import { LoadingService } from '../services/loading.service';

@Component({
  selector: 'app-question',
  templateUrl: './question.component.html',
  styleUrls: ['./question.component.css']
})
export class QuestionComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  @Input() question: ScheduleQuestionAndOptions;
  @Input() examid: any;
  @Input() url: any
  @Input() adminpaused: boolean;
  @Input() proctorpaused: boolean;
  @Input() status: string;
  @Input() scheduleid: number;
  @Input() isQuestionGrouped: boolean = false;

  @Input() essayexam: boolean
  @Input() issaq: boolean
  options: string[] = [];
  @Input() isloadingdata: boolean = false;
  @Input() requiresScreenReader: boolean;
  @Input() liteMode: boolean;
  thisurl = location.origin + '/';

  @Input() loadingSubject: Subject<boolean>;
  @Input() networkFailureSubject: Subject<boolean>;
  @Input() exam: ExamDetails;

  @Output() quesanswered: EventEmitter<number> = new EventEmitter<number>();
  @Output() quesunanswered: EventEmitter<number> = new EventEmitter<number>();
  @Output() quesflagged: EventEmitter<any> = new EventEmitter<any>();
  @Output() qnoclicked: EventEmitter<number> = new EventEmitter<number>();
  @Output() nextclicked: EventEmitter<number> = new EventEmitter<number>();
  @Output() previousclicked: EventEmitter<number> = new EventEmitter<number>();

  @ViewChild('questionhtmlsection') questionhtmlsection: ElementRef;
  @ViewChild('questionbody') questionbody: ElementRef;
  flagged: boolean = false;
  answersubmissioncheck: any;
  markingnotworking: boolean;
  answersubmissionservercheck: any;
  private zoomSub?: Subscription;
  //essayAnswer: string;

  constructor(public questionservice: QuestionserviceService, public examservice: ExamService, public toastr: ToastrService, public router: Router,
    private cbtservice: CbtserviceService, private languageService: LanguageService, private util: UtilService, private cdr: ChangeDetectorRef, private modalService: NgbModal,
    private loadingService: LoadingService) { }
  get language() {
    return this.languageService.language;
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.cdr.detectChanges();
    this.setQuestion();
  }
  ngAfterViewInit(): void {
    this.setQuestion();
  }

  setQuestion() {
    //debugger;
    if (this.questionhtmlsection) {
      if (this.question) {
          this.questionhtmlsection.nativeElement.innerHTML = this.question.examQuestion.questionhtml;
          this.flagged = this.question.examQuestion.flagged;
      }
      else {
        this.questionhtmlsection.nativeElement.innerHTML = '';
      }
      this.questionhtmlsection.nativeElement = QuestionserviceService.cleanMathFieldValues(this.questionhtmlsection.nativeElement);
    }
    document.getElementById('question-container')?.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });

  
  }


  updatedanswer(answer: string) {
    if (this.question.examination.examtype == this.questionservice.Essay) {
      if (this.questionservice.essayAnswerIsNotBlank(answer)) {
        this.quesanswered.emit(this.question.examQuestion.questionno);
      }
      else {
        this.quesunanswered.emit(this.question.examQuestion.questionno);
      }
    }
    else if (this.question.examination.examtype == this.questionservice.SAQ) {
      if (answer != null && answer.trim().length > 0) {
        this.quesanswered.emit(this.question.examQuestion.questionno);
      }
      else {
        this.quesunanswered.emit(this.question.examQuestion.questionno);
      }
    }
    else {
      if (!answer) {
        this.quesunanswered.emit(this.question.examQuestion.questionno);
      }
      else {
        this.quesanswered.emit(this.question.examQuestion.questionno);
      }
    }
  }
  ngOnInit(): void {
    this.zoomSub = this.examservice.zoomQuestionTrigger$.subscribe((increase) => {
      this.zoomExaminationQuestion(increase);
    });

    this.options = [];
  }

  ngOnDestroy() {
    this.zoomSub?.unsubscribe();
  }


  async OnRadioSelected(radiovalue: ScheduleOptionsProp) {
    this.getoptions();

    const data = this.questionservice.constructAnswerSaveData(this.question.examQuestion.schedulequestionid, this.scheduleid, this.options, false, this.question.examination.examid);

    if (this.options && this.options.length > 0) {
      this.questionservice.markanswer(data);

      this.quesanswered.emit(this.question.examQuestion.questionno);

    }
  }

  getoptions(scheduleid = this.question.examQuestion.schedulequestionid) {
    this.options = [];
    var ele = document.getElementsByClassName(scheduleid.toString());
    for (var i = 0; i < ele.length; i++) {
      this.getchecked(ele[i]);
    }
  }
  getchecked(element) {
    if (element.checked) {
      this.options.push(element.value.toString())
    }
  }

  async timeelapsed(elapsed: boolean) {
    if (elapsed) {
      //we get the unsaved answers here so that we get the answers as at the time of elapsed, not on the x-th iteration
      let answers = [];//this.questionservice.getAllQuestionsAnswer().filter(q => !q.saved);
      if (this.question.examination.liteMode) {
        answers = this.questionservice.getAllQuestionsAnswer();
      }
      //wait for 2 seconds to ensure that the candidate is really out of time
      await this.util.sleep(2000);
      let retryAttempt = 0;
      const baseRetryDelayMs = 1000;
      const maxRetryDelayMs = 30000;
      let done = false;
      do {
        try {
          this.isloadingdata = true;
          this.loadingService.show();
          const response: any = await this.examservice.submit(
            this.scheduleid,
            elapsed,
            this.question.examination.examid
          );

          if (response && response.statusmsg && response.statusmsg != "") {
            localStorage.clear();

            this.router.navigate(["/exam/submit"], { queryParams: { scheduleid: this.scheduleid, examid: this.question.examination.examid } });

          }
          else if (response && response.statusmsg == "")
            self.location.reload();

          done = true;
          break;
        }
        catch (error) {
          console.error(error);
          this.cbtservice.showHttpError(error);
        } finally {
          if (done) {
            this.isloadingdata = false;
            this.loadingService.hide();
          } else {
            retryAttempt++;
            const exponentialDelay = Math.min(
              Math.pow(2, retryAttempt - 1) * baseRetryDelayMs,
              maxRetryDelayMs
            );
            const jitter = Math.floor(Math.random() * 1000);
            await this.util.sleep(exponentialDelay + jitter);
          }
        }
      } while (true);
    }

  }

  async oncheckchanged(checkvalue: ScheduleOptionsProp) {
    if (checkvalue.selected)
      this.options.push(checkvalue.optionid.toString());
    else
      this.options = this.options.filter(x => x != checkvalue.optionid.toString());

    this.getoptions();
    var data = {
      schedulequestionid: this.question.examQuestion.schedulequestionid,
      questionid: this.question.examQuestion.questionid,
      scheduleid: this.scheduleid,
      options: this.options,
      essayanswer: "",
      essay: false,
      examid: this.question.examination.examid,
      saq: false,
      saqanswer: ""
    }

    if (this.options) {
      this.questionservice.markanswer(data);

      if (this.options.length == 0) {
        this.quesunanswered.emit(this.question.examQuestion.questionno);
      }
      else {
        this.quesanswered.emit(this.question.examQuestion.questionno);
      }
    }
  }

  flagclicked(flagged: boolean) {
    this.flagged = flagged;
    let qno = this.question.examQuestion.questionno;
    this.quesflagged.emit({ qno, flagged });
  }

  //todo: cleanup
  savequestion(qno: number) {
    this.isloadingdata = true
    this.loadingService.show();

  }

  zoomExaminationQuestion(increase: boolean) {
    if (!this.questionbody) {
      return;
    }

    const element = this.questionbody.nativeElement;

    // Get current zoom from computed style
    const computedZoom = window.getComputedStyle(element).getPropertyValue('zoom');
    const currentZoom = parseFloat(computedZoom) || 1;

    // Adjust zoom level
    let newZoom = currentZoom + (increase ? 0.1 : -0.1);
    newZoom = Math.max(0.5, Math.min(2, newZoom)); // Clamp between 0.5 and 2
    (element.style as any).zoom = newZoom.toString();
  }

  async nextbtnclicked() {
    this.nextclicked.emit(this.question.examQuestion.questionno + 1);
  }

  async prevbtnclicked() {
    this.previousclicked.emit(this.question.examQuestion.questionno - 1);
  }

  async finishclicked() {
    if (this.exam.psychometricTest) {
      const allQuestions =
        await this.questionservice.getAllQuestionDataFromStorage(
          this.scheduleid,
          this.exam.liteMode,
          this.exam.useCaptcha,
          this.examid
        );
        
        const unAnsweredQuestions = this.questionservice.getUnansweredQuestions(allQuestions);
        // Stop flow if user has unanswered questions
        if (unAnsweredQuestions.length > 0) {
           await this.openUnansweredModal(unAnsweredQuestions)
           .then(result => {
            if (result) {
               console.log(result);
              this.noclicked(result);
            }})
           .catch(() => null);
           
           return;
        }
    }

    if (!this.liteMode) {
      await this.questionservice.waitForAllQuestionsToBeSubmitted();
    }

    this.router.navigate(['/exam/submit'], { queryParams: { scheduleid: this.scheduleid, examid: this.examid, url: this.url } });
    localStorage.removeItem(`${this.scheduleid}_post_finish_data`);
  }
  
  openUnansweredModal(questions: any[]) {
    const modalRef = this.modalService.open(UnansweredQuestionsModalComponent, {
      size: 'lg',
      backdrop: 'static',
      keyboard: false,
      centered: true
    });
    
      modalRef.componentInstance.questions = questions;
      return modalRef.result;
  }

   noclicked(qno: number) {
    this.qnoclicked.emit(qno);
  }

}
